module.exports = "<div [attr.class]=\"styleClass\" [class.print]=\"print\"></div>\n"